import { render, staticRenderFns } from "./CreateBuyerDialog.vue?vue&type=template&id=0e99381f&"
import script from "./CreateBuyerDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateBuyerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBuyerDialog.vue?vue&type=style&index=0&id=0e99381f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports